import SearchApi from "../apis/SearchApi";

/**
 * 検索サービスクラス
 */
class SearchService {
  /**
   * データを検索する
   *
   * @param {string} path パス
   * @param {object} search 検索条件
   * @param {number} page ページ数
   * @param {number} perPage 1ページ当たりの件数
   * @param {string} orderBy ソート対象のカラム
   * @param {string} order ソート方法（asc or desc）
   * @memberof SearchService
   */
  async search(
    path,
    search,
    page,
    perPage = this.searchTablePerPage,
    orderBy,
    order,
  ) {
    return await new SearchApi(this).search(
      path,
      search,
      page,
      perPage,
      orderBy,
      order,
    );
  }

  /**
   * LocalStorage に保存した検索条件を取得する
   * @memberof SearchService
   */
  get localSearch() {
    const matches = document.location.pathname.match(/^\/(.+)$/);
    const localSearch = JSON.parse(localStorage.getItem("searchData")) ?? {};
    if (matches) {
      return localSearch[matches[1]] ?? {};
    }
    return {};
  }
  /**
   * 検索条件を LocalStorage に保存する
   *
   * @param {object} searches 検索条件
   * @memberof SearchService
   */
  setLocalSearch(searches) {
    const matches = document.location.pathname.match(/^\/(.+)$/);
    const localSearch = JSON.parse(localStorage.getItem("searchData")) ?? {};
    if (matches) {
      localSearch[matches[1]] = searches;
      localStorage.setItem("searchData", JSON.stringify(localSearch));
    }
  }
  /**
   * LocalStorage に保存した検索条件を削除する
   * @memberof SearchService
   */
  removeLocalSearch(path = "") {
    const matches = document.location.pathname.match(/^\/(.+)$/);
    const localSearch = JSON.parse(localStorage.getItem("searchData")) ?? {};
    if (matches) {
      localSearch[path.replace(/^\//, "") ?? matches[1]] = {};
      localStorage.setItem("searchData", JSON.stringify(localSearch));
    }
  }
  /**
   * LocalStorage に保存したテーブルの件数を返却する
   * @memberof SearchService
   */
  get searchTablePerPage() {
    const perPage = window.localStorage.getItem("searchTablePerPage");
    if (!perPage) this.setSeachTablePerPage(100);
    return Number(perPage ?? 100);
  }
  /**
   * テーブルの件数を LocalStorage に保存する
   *
   * @param {string} perPage テーブルの件数
   * @memberof SearchService
   */
  setSeachTablePerPage(perPage) {
    window.localStorage.setItem("searchTablePerPage", perPage);
  }
}
export const searchService = new SearchService();
